import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IQuestionType } from "../../../Pages/QuestionType/IQuestionType";

type GetQuestionSubTypeState = {
  id?: number;
  subtype_name?: string;
  question_type_name?: string;
  subject_name?: string;
  year_group?: string;
  state?: string;
  full_name?: string;
  Status?: boolean;
  sequence?: number | null;
  description?: string | null;
  data?: any;
  isLoading: boolean;
};

const initialState: IReduxState<GetQuestionSubTypeState> = {
  data: {} as GetQuestionSubTypeState,
  isLoading: false,
};

export const GetQuestionSubTypeSlice = createSlice({
  name: "GetQuestionSubTypeSlice",
  initialState: initialState,
  reducers: {
    GetQuestionSubType: (state) => {
      state.isLoading = true;
    },
    successGetQuestionSubType: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureGetQuestionSubType: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  failureGetQuestionSubType,
  GetQuestionSubType,
  successGetQuestionSubType,
} = GetQuestionSubTypeSlice.actions;

export default GetQuestionSubTypeSlice.reducer;
